import APPLE from "./imgs/apple.jpg";
import BEEFSTEAK from "./imgs/beefSteak.jpg";
import CHICKENBREAST from "./imgs/chickenBreast.jpg";
import SPINACH from "./imgs/spinach.jpg";

export const apple = APPLE;
export const beefSteak = BEEFSTEAK;
export const chickenBreast = CHICKENBREAST;
export const spinach = SPINACH;
